import TimeString from './TimeString'
import TimeStringRange from './TimeStringRange'

TimeString.Range = TimeStringRange

export default TimeString
